import HomeComp from "modules/home/index.js";
import Head from "next/head";

export default function Home() {
  return (
    <>
      <Head>
        <title>Thank you for your continuous support.</title>
        <meta
          property="og:title"
          content="Thank you for your continuous support."
          key="title"
        />
        <link rel="canonical" href="https://www.shopraha.com/" />
      </Head>
      <main>
        <HomeComp />
      </main>
    </>
  );
}
